import { composeValidators, validate } from '@alfa-bank/site-form-helpers/validation/utils';
import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';
import type { TValidatorValue } from '@alfa-bank/site-form-helpers/src/validation/models';
import { DEFAULT_PHONE_MESSAGE } from '@alfa-bank/site-form-helpers/validation/phone';
import { isValidAlfaPhone } from '@alfa-bank/site-form-helpers/validation/alfa-phone';

const validateAlfaPhoneValue = (value: TValidatorValue) =>
    validate(isValidAlfaPhone(value), DEFAULT_PHONE_MESSAGE);

export const validate940 = (value: string) =>
    validate(!/^\+7 \(940/.test(value), 'Код оператора не может быть 940');

// Может начинаться только с +7 (9xx), запрещено все кроме (9xx)
export const validateOperatorCode = (value: string) =>
    validate(!/^\+7 \([0-8]/.test(value), DEFAULT_PHONE_MESSAGE);

export const validatePhone = () =>
    composeValidators(
        validateNotEmpty(DEFAULT_PHONE_MESSAGE),
        validateOperatorCode,
        validateAlfaPhoneValue,
        validate940
    );
